module.exports = __webpack_public_path__ + "img/imagen_parrafo_2.a6acc621.jpg";